import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { featureSelector } from 'reducers/app.reducer';
import StoreFooter from './StoreFooter';
import LegalBanner from './LegalsLinksFooter';

export const Footer: React.FC = () => {
  const isHidden = !!useRouteMatch({
    path: '/auth',
    strict: true,
    sensitive: true,
  });
  const storeFeature = useSelector(featureSelector('use_store'));
  const canAccessStore = storeFeature?.data?.enabled;

  if (isHidden) {
    return null;
  }
  return (
    <div>
      {canAccessStore && <StoreFooter />}
      <LegalBanner />
    </div>
  );
};

export default Footer;
